import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'

import { PageHeader } from '@/components/headers/PageHeader'
import { OrganizationFilter } from '@/components/filters/OrganizationFilter'
import { FilterForm } from '@/components/filters/FilterForm'
import { Menu } from '@/components/navigation/Menu'
import { getOrganizationOptions } from '@/utils/helpers'
import { fetchScorecardsByOrg } from '@/reducers/scorecards/scorecards.actions'

import BulkRescoreTab from './BulkRescoreTab'
import BulkScoreTab from './BulkScoreTab'

const RESCORE_TAB = 'rescore'
const BULK_SCORE_TAB = 'bulkScore'

const BulkRescorePage = () => {
  const dispatch = useDispatch()
  const { organizations } = useSelector((state) => state)
  const currentUser = useSelector((state) => state.currentUser)

  const organizationId = currentUser.organizationid
  const organizationOptions = getOrganizationOptions(organizations)

  const [selectedOrgId, setSelectedOrgId] = useState(organizationId)
  const [activeTab, setActiveTab] = useState(RESCORE_TAB)

  useEffect(() => {
    if (selectedOrgId) {
      dispatch(fetchScorecardsByOrg(selectedOrgId, 'copilot'))
    }
  }, [selectedOrgId])

  const handleOrgSelect = (option, action) => {
    if (action.action === 'clear') {
      setSelectedOrgId(null)
    } else {
      setSelectedOrgId(option.value)
    }
  }

  const tabItems = [
    {
      accessor: RESCORE_TAB,
      label: 'Rescore Criteria',
      active: activeTab === RESCORE_TAB,
      onClick: () => setActiveTab(RESCORE_TAB),
    },
    {
      accessor: BULK_SCORE_TAB,
      label: 'Bulk Scoring',
      active: activeTab === BULK_SCORE_TAB,
      onClick: () => setActiveTab(BULK_SCORE_TAB),
    },
  ]

  return (
    <div data-testid="bulk-rescore-page">
      <PageHeader title="Bulk Operations" />

      {!isEmpty(organizationOptions) && (
        <FilterForm small>
          <OrganizationFilter
            options={organizationOptions}
            value={selectedOrgId}
            onChange={handleOrgSelect}
          />
        </FilterForm>
      )}

      <Menu items={tabItems} className="mt" />
      {activeTab === RESCORE_TAB && <BulkRescoreTab selectedOrgId={selectedOrgId} />}
      {activeTab === BULK_SCORE_TAB && <BulkScoreTab selectedOrgId={selectedOrgId} />}
    </div>
  )
}

export default BulkRescorePage
